module.exports = __webpack_public_path__ + "static/media/moduleManagerIconTrans.11787301.svg";